import {
  ATTACH_SUPPLIER_DIALOG,
  CATALOG_DIALOG,
  COMMENT_DIALOG,
  IMAGE_CROPPER_DIALOG,
  IMAGE_DIALOG,
  INFO_DIALOG,
  LOGIN_DIALOG,
  MAP_DIALOG,
  OPEN_DIALOG,
} from 'redux/types';

const INIT_STATE = {
  open: false,
  data: {},
  changedValue: {},
  name: '',
  onConfirm: function () {
    return;
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case OPEN_DIALOG:
      return { ...state, ...action.payload };
    case LOGIN_DIALOG:
      return { ...state, ...action.payload };
    case COMMENT_DIALOG:
      return { ...state, ...action.payload };
    case CATALOG_DIALOG:
      return { ...state, ...action.payload };
    case ATTACH_SUPPLIER_DIALOG:
      return { ...state, ...action.payload };
    case IMAGE_DIALOG:
      return { ...state, ...action.payload };
    case MAP_DIALOG:
      return { ...state, ...action.payload };
    case INFO_DIALOG:
      return { ...state, ...action.payload };
    case IMAGE_CROPPER_DIALOG:
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};
